<div class="fs-2 with-close" mat-dialog-title>
    Ne manquez pas les prochains biens rentables
</div>
<div mat-dialog-content>
    <div class="text-center" *ngIf="step == '1'">
        <h1 class="mt-4 mb-4">Votre période d’essai a expiré.</h1>
        <p class="semi-bold">Choisissez votre forfait pour ne pas manquer les prochains biens rentables</p>
        <button class="btn btn-primary btn-lg mt-4" (click)="nextStep()">Choisir un forfait</button><br/>
        <img class="img-fluid" src="assets/Annonces.png"><br/>
    </div>
    <div *ngIf="step == '2'">
        <h1 class="mt-4 mb-4 text-center">Choisissez le bon forfait pour votre recherche</h1>
        <p class="semi-bold text-center">Pas encore prêt ? Revenez à notre <a class="text-decoration-underline text-black" (click)="onNoClick()">Forfait Gratuit</a></p>

        <div class="row d-flex justify-content-around align-items-stretch pricing mt-5">

            <div class="text-center mb-3 col-12">
                <div id="plan" class="duration_choose mb-3">
                    <div class="duration {{ duration == 'month' ? 'active' : ''}}" (click)="setDuration('month')">
                        Mensuel
                    </div>
                    <div class="duration {{ duration == 'quarter' ? 'active' : ''}}" (click)="setDuration('quarter')">
                        Trimestriel
                        <div class="discount">
                            -10%
                        </div>
                    </div>
                    <div class="duration {{ duration == 'year' ? 'active' : ''}}" (click)="setDuration('year')">
                        Annuel
                        <div class="discount">
                            -20%
                        </div>
                    </div>
                </div>
                <b>
                    Sans engagement - Résiliable à tout moment
                </b>
            </div>

            <div class="col-12 position-relative" [ngClass]="{'promo-padding': promo}">
                <div class="row justify-content-center">
                    <div class="col-basique">
                        <div class="pricing-light">
                            <h2 class="basique pb-3">Basique</h2>
                            <p class="desc">Pour les investisseurs débutants qui veulent <b>se rassurer avant de se lancer.</b></p>
                            <b class="price">
                                <s class="promo"
                                   *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'projetlocatif' || promo == 'onboarding'">
                                    ({{ userService.getPrice("basique", duration, user, promo)[1] | number:'1.0-2' }} €)
                                </s>
                                <img *ngIf="promo == 'bf'" src="assets/promo-bf.png"/>
                                {{ userService.getPrice("basique", duration, user, promo)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
                                <small
                                    *ngIf="(promo == 'bf' || promo == 'rentree') && (duration == 'month' || duration == 'quarter')">Pendant
                                    3 mois</small>
                            </b>
                            <span class="diff_annuel" *ngIf="userService.getPrice('basique', duration, user, promo)[2] > 0">
                                ECONOMISEZ {{ userService.getPrice('basique', duration, user, promo)[2] }}€/AN EN PAYANT A L'ANNEE
                            </span>

                            <a class="btn btn-outline-primary"
                               *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == '' && user.subscription.plan == ''"
                               (click)="planSelect('basique')">
                                <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                                <span [hidden]="loading">Choisir ce forfait</span>
                            </a>

                            <h4>Fonctionnalités :</h4>
                            <ul class="pricing-features">
                                <li>
                                    Extension navigateur
                                    <i class="fa fa-question-circle ms-2" matTooltipClass="tooltip-button"
                                       matTooltip="Extension disponible sur Google Chrome et Mozilla Firefox. Compatible avec Leboncoin, SeLoger, Logic Immo et AvendreAlouer"></i>
                                </li>
                                <li>Accès à la communauté WhatsApp et aux Webinaires</li>
                                <li>Analyse du marché immobilier</li>
                                <li>
                                    Calcul de rendement et de CF
                                    <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                                       matTooltip="Simulateur d’investissement locatif : Calculez simplement et rapidement le rendement, le cash-flow et la fiscalité de votre investissement locatif sur les 30 prochaines années"></i>
                                </li>
                                <li>Simulation en Foncier et LMNP
                                    <i class="fa fa-question-circle ms-2"
                                       matTooltipClass="tooltip-button"
                                       matTooltip="Foncier forfait, foncier réel, LMNP forfait, LMNP réel"></i>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="col-essentiel">
                        <div class="p-4 pt-3 pb-3 populaire bg-primary text-white">
                            POPULAIRE
                            <img src="https://www.lybox.fr/build/images/flag_pop.png.webp" alt="Populaire"/>
                        </div>
                        <div class="pricing-light active">
                            <h2 class="essentiel pb-3">Essentiel</h2>
                            <p class="desc">
                                Pour les investisseurs <b>en recherche active</b> qui souhaitent trouver des biens rentables.
                            </p>
                            <b class="price">
                                <s class="promo"
                                   *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'projetlocatif' || promo == 'onboarding'">
                                    ({{ userService.getPrice("essentiel", duration, user, promo)[1] | number:'1.0-2' }} €)
                                </s>
                                <img *ngIf="promo == 'bf'" src="assets/promo-bf.png"/>
                                {{ userService.getPrice("essentiel", duration, user, promo)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
                                <small
                                    *ngIf="(promo == 'bf' || promo == 'rentree') && (duration == 'month' || duration == 'quarter')">Pendant
                                    3 mois</small>
                            </b>
                            <span class="diff_annuel" *ngIf="userService.getPrice('essentiel', duration, user, promo)[2] > 0">
                                ECONOMISEZ {{ userService.getPrice('essentiel', duration, user, promo)[2] }}€/AN EN PAYANT A L'ANNEE
                            </span>

                            <a class="btn btn-primary"
                               *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == '' && user.subscription.plan == ''"
                               (click)="planSelect('essentiel')">
                                <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                                <span [hidden]="loading">Choisir ce forfait</span>
                            </a>
                            <h4>Fonctionnalités dans Basique, et : </h4>
                            <ul class="pricing-features">
                                <li>
                                    Moteur de recherche spécial investisseur (1500 sites réunis)
                                    <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                                       matTooltip="Moteur de recherche immobilier : Retrouvez toutes les annonces immobilières du web au même endroit. Faites des recherches précises en se basant sur plus de 30 critères conçus pour les investisseurs"></i>
                                </li>
                                <li>Filtres de recheche avancés</li>
                                <li>
                                    Trouver les villes rentables
                                    <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                                       matTooltip="Trouver les villes rentables : Un module de recherche vous permet de trouver les villes à potentiel dans votre département ou autour de chez vous, en fonction de vos objectifs d’investissement"></i>
                                </li>
                                <li>Imposition à la revente
                                    <i class="fa fa-question-circle ms-2"
                                       matTooltipClass="tooltip-button"
                                       matTooltip="Calculez l'impôt sur la plus value en fonction de votre situation, votre régime fiscal et l'année de revente"></i></li>
                                <li>Simulation en SCI à l’IS</li>
                            </ul>

                        </div>
                    </div>
                    <div class="col-expert">
                        <div class="pricing-light">
                            <h2 class="expert pb-3">Expert</h2>
                            <p class="desc">
                                Pour les investisseurs exigeants qui veulent êtes les premiers sur les meilleures affaires.
                            </p>
                            <b class="price">
                                <s class="promo"
                                   *ngIf="promo == 'bf' || promo == 'rentree' || promo == 'partner' || promo == 'projetlocatif' || promo == 'onboarding'">
                                    ({{ userService.getPrice("expert", duration, user, promo)[1] | number:'1.0-2' }} €)
                                </s>
                                <img *ngIf="promo == 'bf'" src="assets/promo-bf.png"/>
                                {{ userService.getPrice("expert", duration, user, promo)[0]|number:'1.0-2' }} €<span class="fs-5">/mois</span>
                                <small
                                    *ngIf="(promo == 'bf' || promo == 'rentree') && (duration == 'month' || duration == 'quarter')">Pendant
                                    3 mois</small>
                            </b>
                            <span class="diff_annuel" *ngIf="userService.getPrice('expert', duration, user, promo)[2] > 0">
                            ECONOMISEZ {{ userService.getPrice('expert', duration, user, promo)[2] }}€/AN EN PAYANT A L'ANNEE
                        </span>

                            <a class="btn btn-outline-primary"
                               *ngIf="(user.plan == '' || user.plan == 'trial') && user.pro_plan == '' && user.subscription.plan == ''"
                               (click)="planSelect('expert')">
                                <mat-spinner diameter="25" [hidden]="!loading"></mat-spinner>
                                <span [hidden]="loading">Choisir ce forfait</span>
                            </a>
                            <h4>Fonctionnalités dans Essentiel, et :</h4>
                            <ul class="pricing-features">
                                <li>
                                    Alertes mails en direct
                                    <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                                       matTooltip="Alertes mails en direct : Soyez avertis automatiquement lorsqu’une nouvelle annonce qui correspond à vos critères est publiée sur n’importe quel site immobilier"></i>
                                </li>
                                <li>
                                    Dossier bancaire en PDF
                                    <i class="fa fa-question-circle  ms-2" matTooltipClass="tooltip-button"
                                       matTooltip="Dossier bancaire : Mettez toutes les chances de votre côté pour obtenir votre crédit immobilier. Vous pourrez générer un rapport d’investissement professionnel en PDF détaillant chaque aspect de votre projet immobilier"></i>
                                </li>
                                <li>Accès aux locaux commerciaux</li>
                                <li>Personnalisation avancée
                                    <i class="fa fa-question-circle ms-2"
                                       matTooltipClass="tooltip-button"
                                       matTooltip="Personnalisation des indicateurs dans les resultats de recherches et les favoris"></i></li>
                                <li>Simulation en LMP, SASU, EURL ...<br/><br/></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
